export default __webpack_public_path__ + "static/media/Minicard_2h.af7dd815.svg";